import { createContext, useContext, type ReactNode } from 'react';

import type { ProjectChatCreditChrome } from './ProjectChat';

/** The chat's credit chrome, read as a hook so the banner state stays with the caller. */
export type UseWorkCreditAllowanceChrome = (options: {
  inThread: boolean;
}) => ProjectChatCreditChrome;

const STUB_CHROME: ProjectChatCreditChrome = {
  composerDockLeading: null,
  transcriptTrailing: null,
  hideFollowUpQuestions: false,
  sendDisabled: false,
};

const stubChrome: UseWorkCreditAllowanceChrome = () => STUB_CHROME;

const WorkCreditAllowanceChromeContext =
  createContext<UseWorkCreditAllowanceChrome>(stubChrome);

export const WorkCreditAllowanceChromeProvider = ({
  useChrome,
  children,
}: {
  useChrome: UseWorkCreditAllowanceChrome;
  children: ReactNode;
}): JSX.Element => (
  <WorkCreditAllowanceChromeContext.Provider value={useChrome}>
    {children}
  </WorkCreditAllowanceChromeContext.Provider>
);

/** Package-internal. With no provider this returns the no-hook stub. */
export const useWorkCreditAllowanceChrome = (options: {
  inThread: boolean;
}): ProjectChatCreditChrome => useContext(WorkCreditAllowanceChromeContext)(options);
